var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-buttons-wrapper"},_vm._l((_vm.links),function(link){return _c('a',{key:link.name,staticClass:"auth-buttons-item paragraph-s",on:{"click":link.click}},[_vm._v(_vm._s(link.name))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }